import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Header,
  StyledButton,
  StyledCard,
  Subtext,
} from "./CheckYourMailbox.styled";
import { AuthContainer } from "./Auth.styled";
import Logo from "../../assets/images/taia_logo.png";
import { usePageTitle } from "../../hooks/usePageTitle";
import { PageTitleKeys } from "../../config/routeConstants";
import { useTranslation } from 'react-i18next';
import LogoWithLanguageSwitcher from '../../components/common/LogoWithLanguageSwitcher';

const EmailConfirmed: React.FC = () => {
  usePageTitle(PageTitleKeys.EmailConfirmed);
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (
    <AuthContainer role="region" aria-labelledby="email-confirmed-title">
      <LogoWithLanguageSwitcher src={Logo} alt={t('auth.logo.alt')} clickable={false} />
      <StyledCard>
        <Header id="email-confirmed-title">{t('emailConfirmed.title')}</Header>
        <Subtext>{t('emailConfirmed.subtitle')}</Subtext>
        <StyledButton onClick={() => navigate("/login")} aria-label={t('emailConfirmed.buttonText.ariaLabel') as string}>
          {t('emailConfirmed.buttonText')}
        </StyledButton>
      </StyledCard>
    </AuthContainer>
  );
};

export default EmailConfirmed;
